import * as server from '@/utils/server-wrapper'
// import {getJsonResult, getJsonResultV2} from "../utils/server-wrapper";
// 登录方法
export function login (username, password, uuid = '', captchaCode = '') {
  const data = {
    username,
    password,
    uuid,
    captchaCode
  }
  return server.postJsonReturnV1(
    '/login', data
  )
}
// 注册
export function register (username, code, password, referer = '', platform = 'MOBILE_WEB') {
  const data = {
    username,
    code,
    password,
    registerReferer: referer,
    registerPlatform: platform
  }
  return server.postJsonReturnV1(
    '/registerByCode', data
  )
}
export function getInfo () {
  return server.getJsonResult('/getInfo')
}
export function captchaImage () {
  return server.getJsonResult('/captchaImage')
}



// WEBPACK FOOTER //
// ./src/api/login.js